module.exports = __webpack_public_path__ + "img/icon_map_81_on.a52146fa.png";